export default __webpack_public_path__ + "static/media/greenlight.a699dc7f.svg";